import A11yDialog from 'a11y-dialog';


export default function videoPanel() {
  
  jQuery(document).ready(function( $ ) {

    $('[data-a11y-dialog-show]').click(function(e) {
      e.preventDefault();
    });

    // Get the dialog element
    $( '.full-width-video-modal' ).each( function( e ) {
      const $modal = $(this);
      const el = $(this)[0];
      const dialog = new A11yDialog( el );

      dialog.on( 'show', function ( dialogEl, event ) {
        // disable scroll on body
        $('body').css('overflow', 'hidden');

        // if video modal, play video
        let $modal = $( dialogEl );
        let $video = $modal.find('[data-video-embed]');
        
        if ( $video ) {
          var code = $video.data( 'video-embed' );
          $video.html( code );
        }
      });

      dialog.on('hide', function (dialogEl, event) {
        // enable body scroll
        $('body').css('overflow', 'visible');
        
        // if video modal, remove video
        var $modal = $(dialogEl);
        
        $( '.full-width-video-modal' ).each( function( e ) {
          $(this).attr( 'aria-hidden', 'true' );
        });

        let $video = $modal.find('[data-video-embed]');
        if ( $video ) {
          $video.html('');
        }
      });
    });


  });
}
